<template>
	<div>
		<transition name="fade">
		<div class="retreat-box" v-if="show"> 
	    	<h3>提示</h3>
	    	<p v-html="msg"></p>
	    	<button @click="cancalRetreat">取消</button>
	    	<button id="ok-retreat" @click="okRetreat">确定</button>
	    </div>
	    </transition>
	    <div class="mask" v-if="show"></div>
    </div>
</template>

<script>
	export default {
		props:{
			show:{
				type:Boolean,
				default:false
			},
			msg:{
				type:String,
				default:''
			} 
		},
		data(){
			return {

			}
		},
		mounted(){

		},
		methods:{ 
			cancalRetreat(){ 
				this.$emit('cancal')
			},
			okRetreat(){
				this.$emit('ok')
			}
		} 
	}
</script>

<style scoped lang="less">
	.mask{
		width:100%;
		height:100%;
		background: #000;
		opacity: .3;
		position: fixed;
		z-index: 3;
	}
	.retreat-box{ 
		font-size: 18px;
		width:400px;
		height:250px;
		position: fixed;
		z-index: 4;
		top:50%;
		left:50%;
		margin-left:-200px;
		margin-top: -125px;
		border-radius: 6px;
		text-align: center;
		background: #fff;
		h3{
			margin:30px;
		}
		p{
			margin:30px 0;
		}
		button{
			width:130px;
			height:50px;
			border:0;
			border-radius: 4px;
			background: #fff; 
			margin:15px;
			color:#40DC23;
			border:1px solid #40DC23;
			cursor: pointer;
		}
		button:last-child{
			background: #40DC23;  
			color:#fff;
		}
	}
	.fade-enter-active {
	  animation: bounce-in .4s;
	}
	.fade-leave-active {
	  animation: bounce-in .4s reverse;
	}
	@keyframes bounce-in {
	  0% {
	    transform: scale(.2);
	  } 
	  100% {
	    transform: scale(1);
	  }
	}
</style>